function Header({ switchType }) {
  const renderSwitch = () => {
    if (switchType === 'home') {
      return (
        <a href="projects" className="py-3 px-5 bg-red-500 hover:bg-red-600 font-bold uppercase rounded-full">projects</a>
      );
    } else if (switchType === 'projects') {
      return (
        <>
          <a href="/" className="py-3 px-5 mx-1 bg-red-500 hover:bg-red-600 font-bold uppercase rounded-full">home</a>
          <a href="https://github.com/ArtByteFilip" className="py-3 px-5 mx-1 bg-red-500 hover:bg-red-600 font-bold uppercase rounded-full">github</a>
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      <header className="bg-red-900 bg-repeat" style={{ backgroundImage: "url(./imgs/noise.png)" }}>
        <div className="container max-w-screen-sm mx-auto py-12 pb-14 text-center text-white">
          <h2 className="text-2xl">Hi I'm Filip</h2>
          <h1 className="font-bold text-5xl my-2">FULL-STACK DEVELOPER</h1>
          <h3 className="text-base mb-6">Web/Software/Game development</h3>
          {renderSwitch()}
        </div>
      </header>
    </>
  );
}

export default Header;
